export default __webpack_public_path__ + "static/media/team-member-1.95978b98.png";